export enum PaymentMethodCodesEnum {
    //AirlineWallet = 'WT',
    Card = 'C',
    GooglePay = 'GP',
    ApplePay = 'AP',
    PayPal = 'PP',
    Revolut = 'RV',
}

export const PaymentMethodsSortOrder: Record<string, number> = {
    //[PaymentMethodCodesEnum.AirlineWallet]: 100,
    [PaymentMethodCodesEnum.ApplePay]: 200,
    [PaymentMethodCodesEnum.Card]: 300,
    [PaymentMethodCodesEnum.Revolut]: 400,
    [PaymentMethodCodesEnum.PayPal]: 500,
    [PaymentMethodCodesEnum.GooglePay]: 600,
}

export enum CardNetworksEnum {
    Visa = 'VI',
    MasterCard = 'MC',
    Maestro = 'MA',
    Diners = "DS",
    Discover = "DV",
}